// extracted by css-extract-rspack-plugin
export default {"root":"root-COGyya","btn":"btn-Op91Vm","providersRoot":"providersRoot-bVFF32"};